<template>
  <div>
    <ul class="nav nav-tabs inner row no-gutters">
      <li
        class="nav-item col-6 col-sm-4 col-md-2"
        v-for="tab in tabs"
        :key="tab"
        v-bind:class="{
          'tab-head--active': activeTab === tab,
        }"
        v-on:click="switchTab(tab)"
      >
        <a
          href="javascript:;"
          class="nav-link"
          v-bind:class="{
            active: activeTab === tab,
          }"
        >
          <slot :name="tabHeadSlotName(tab)">{{ tab }} </slot>
        </a>
      </li>
    </ul>
    <div class="tab-content">
      <div class="tab-pane fade active show">
        <slot :name="tabPanelSlotName"> </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initialTab: String,
    tabs: Array,
  },
  data() {
    return {
      activeTab: this.initialTab,
    };
  },
  computed: {
    tabPanelSlotName() {
      return `tab-panel-${this.activeTab}`;
    },
  },
  methods: {
    tabHeadSlotName(tabName) {
      return `tab-head-${tabName}`;
    },

    switchTab(tabName) {
      this.activeTab = tabName;
      this.$emit('currentTabMethod', tabName);
    },
  },
};
</script>
